<template>
  <form-main @back="makeSureBack">
    <template slot="nav">
      <div class="stuDetailNav">
        <p>培训公开讲师信息</p>
        <p class="downResume" @click="downResume">下载预览</p>
      </div>
      
    </template>
    <template slot="main">
      <div class="stuDetailMain">
        <div
             class="scrollArea">
          <vue-scroll :ops="ops">
            <div class="contentWrap">
              <div class="content">
                <div class="itemWrap">
                  <div class="titleWrap">
                    <div class="title">
                      <v-icon class="logo"
                              name="regular/address-book"
                              scale="1.8"></v-icon>
                      <p>基本信息</p>
                    </div>
                  </div>
                  <div class="stuInfo">
                    <div class="left">
                      <div class="tr level">
                        <div class="td" >{{levelInfo.teacher_level}}</div>
                        <div class="td" v-if="levelInfo.teacher_level_g">{{levelInfo.teacher_level_g}}</div>
                        <div class="td" v-if="levelInfo.teacher_level_physical">{{levelInfo.teacher_level_physical}}</div>
                      </div>
                      <div class="tr level">
                        <div class="td" >{{levelInfo.rank_level}}</div>
                        <div class="td" v-if="levelInfo.rank_level_special">{{levelInfo.rank_level_special}}</div>
                        <div class="td" v-if="levelInfo.rank_level_physical">{{levelInfo.rank_level_physical}}</div>
                      </div>
                      <div class="tr">
                        <div class="td">注册协会：{{userInfo.work_unit}}</div>
                      </div>
                    </div>
                    <div class="right">
                      <img :src="!userInfo.profile_picture?userImg:userInfo.profile_picture"
                           @error="imgError"
                           alt="">
                      <p class="name">{{userInfo.name}}</p>
                    </div>
                  </div>
                  <el-form :model="resumeDataForm"
                    ref="resumeDataForm"
                    label-width="120px"
                    size="medium">
                    <fieldset class="vita-form-fieldset">
                      <legend>执教经历</legend>
                      <el-row v-for="(col, index) in resumeDataForm.resumeDataCoach"
                        class="vita-edu-row">
                        <el-col :span="20">
                          <el-row>
                            <el-col>
                              <el-form-item label="执教经历" style="color:white">
                                <el-input v-model.trim="col.content"
                                  maxlength="34" show-word-limit
                                  placeholder="请输入执教经历"></el-input>
                              </el-form-item>
                            </el-col>
        
                          </el-row>
                        </el-col>
                        <el-col :span="4">
                          <el-row class="exp-opt">
                            <el-col :span="6"
                              :offset="6">
                              <el-button type="primary"
                                size="small"
                                icon="el-icon-plus"
                                @click="addHonor"
                                circle></el-button>
                            </el-col>
                            <el-col :span="8"
                              :offset="4">
                              <el-button v-show="resumeDataForm.resumeDataCoach.length !== 1"
                                type="danger"
                                size="small"
                                icon="el-icon-minus"
                                @click="delHonor(index)"
                                circle></el-button>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </fieldset>
  
                    <fieldset class="vita-form-fieldset">
                      <legend>运动经历</legend>
                      <el-row v-for="(col, index) in resumeDataForm.resumeDataPlay"
                        class="vita-edu-row">
                        <el-col :span="20">
                          <el-row>
                            <el-col>
                              <el-form-item label="运动经历" style="color:white">
                                <el-input v-model.trim="col.content"
                                  maxlength="34" show-word-limit
                                  placeholder="请输入运动经历"></el-input>
                              </el-form-item>
                            </el-col>
        
                          </el-row>
                        </el-col>
                        <el-col :span="4">
                          <el-row class="exp-opt">
                            <el-col :span="6"
                              :offset="6">
                              <el-button type="primary"
                                size="small"
                                icon="el-icon-plus"
                                @click="addPlay"
                                circle></el-button>
                            </el-col>
                            <el-col :span="8"
                              :offset="4">
                              <el-button v-show="resumeDataForm.resumeDataPlay.length !== 1"
                                type="danger"
                                size="small"
                                icon="el-icon-minus"
                                @click="delPlay(index)"
                                circle></el-button>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </fieldset>
  
                    <fieldset class="vita-form-fieldset">
                      <legend>其他相关经历</legend>
                      <el-row v-for="(col, index) in resumeDataForm.resumeDataOther"
                        class="vita-edu-row">
                        <el-col :span="20">
                          <el-row>
                            <el-col>
                              <el-form-item label="其他相关经历" style="color:white">
                                <el-input v-model.trim="col.content"
                                  maxlength="34" show-word-limit
                                  placeholder="请输入其他相关经历"></el-input>
                              </el-form-item>
                            </el-col>
        
                          </el-row>
                        </el-col>
                        <el-col :span="4">
                          <el-row class="exp-opt">
                            <el-col :span="6"
                              :offset="6">
                              <el-button type="primary"
                                size="small"
                                icon="el-icon-plus"
                                @click="addOther"
                                circle></el-button>
                            </el-col>
                            <el-col :span="8"
                              :offset="4">
                              <el-button v-show="resumeDataForm.resumeDataOther.length !== 1"
                                type="danger"
                                size="small"
                                icon="el-icon-minus"
                                @click="delOther(index)"
                                circle></el-button>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </fieldset>
                  </el-form>
                  
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
        <div class="btns">
          <el-button type="primary"
            @click="checkForm">保存
          </el-button>
          <el-button type="danger"
            @click="makeSureBack">取消</el-button>
        </div>
        <yioks-tips :showTips="submitTips"
          tips="确定保存吗？"
          @hideTips="hideSubmitTips"></yioks-tips>
        <yioks-tips :showTips="backTips"
          tips="确定放弃修改并返回吗？"
          @hideTips="hideBackTips"></yioks-tips>
      </div>
    </template>
  </form-main>
</template>

<script>
  import "vue-awesome/icons/regular/address-book";
  import "vue-awesome/icons/regular/flag";
  import "vue-awesome/icons/regular/file-alt";

  import ops from '@/assets/js/vuescrollOption';
  import userImg from "@/assets/images/person.png";
  import Img from "@/assets/images/plan_default.png";
  import {getTeacherResumeInfo,teacherResumeSave} from "@/api/training_teacher/api";
  import { correctStatus } from "@/assets/js/apiStatus";
  import commonFun from "@/assets/js/yioks";
  import {getTeacherResumeDown} from "@/api/common/api";
  import fiveMixins from "@/minix/fiveMixins";
  const { downfile } = commonFun;
  export default {
    name: "teacher-resume",
    mixins: [fiveMixins],
    data() {
      return {
        ops: ops(),
        userImg: userImg,
        submitTips: false,
        backTips: false,
        imgSrc: Img,
        userInfo: {},
        levelInfo: {},
        tmpPlayExp:[],
        tmpOtherExp:[],
        resumeDataForm: {
          resumeDataCoach: [{
            content:'',
            type:'coach',
          }],
          resumeDataPlay: [{
            content:'',
            type:'play',
          }],
          resumeDataOther: [{
            content:'',
            type:'other',
          }],
        },
      };
    },
    filters: {
    
    },
    components: {
      "form-main": () => import("@/components/LayOut/Common/up-down"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "tutorial-type": () => import("@/components/Tutorial/tutorial-type"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-tips": () => import('@/components/Tips/Dialog'),
    },
    created() {
      this.getStuInfo();
      
    },
    mounted() {
    
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getStuInfo() {
        getTeacherResumeInfo().then((res) => {
          const {userInfo, levelInfo, resumeData} = res.data.result;
          this.userInfo = userInfo;
          this.levelInfo = levelInfo;
          let resumeDataCoach = [];
          let resumeDataPlay = [];
          let resumeDataOther = [];
          resumeData.map(item=>{
            if(item.type ==='coach') {
              resumeDataCoach.push(item);
            }
            if(item.type ==='play') {
              resumeDataPlay.push(item);
            }
            if(item.type ==='other') {
              resumeDataOther.push(item);
            }
          })
          if(resumeDataCoach.length>0){
            this.resumeDataForm.resumeDataCoach = resumeDataCoach;
          }
          if(resumeDataPlay.length>0){
            this.resumeDataForm.resumeDataPlay = resumeDataPlay;
          }
          if(resumeDataOther.length>0){
            this.resumeDataForm.resumeDataOther = resumeDataOther;
          }
        })
        .catch((err) => {
          console.error(err);
        });
      },
  
      // 最多加8个
      addHonor(){
        let num = this.resumeDataForm.resumeDataCoach.length + this.resumeDataForm.resumeDataPlay.length + this.resumeDataForm.resumeDataOther.length
        if(num >= 8){
          this.$message({
            type: "error",
            message: "根据中国足协提供的培训指导手册排版限制，执教经历、运动经历、其他相关经历一共最多可写8条"
          });
          return;
        }
        this.resumeDataForm.resumeDataCoach.push({
          content:'',
          type:'coach',
        })
      },
      delHonor(idx){
        if (this.resumeDataForm.resumeDataCoach.length === 1) return;
        this.resumeDataForm.resumeDataCoach.splice(idx, 1);
      },
      addPlay(){
        let num = this.resumeDataForm.resumeDataCoach.length + this.resumeDataForm.resumeDataPlay.length + this.resumeDataForm.resumeDataOther.length
        if(num >= 8){
          this.$message({
            type: "error",
            message: "根据中国足协提供的培训指导手册排版限制，执教经历、运动经历、其他相关经历一共最多可写8条"
          });
          return;
        }
        this.resumeDataForm.resumeDataPlay.push({
          content:'',
          type:'play',
        })
      },
      delPlay(idx){
        if (this.resumeDataForm.resumeDataPlay.length === 1) return;
        this.resumeDataForm.resumeDataPlay.splice(idx, 1);
      },
      addOther(){
        let num = this.resumeDataForm.resumeDataCoach.length + this.resumeDataForm.resumeDataPlay.length + this.resumeDataForm.resumeDataOther.length
        if(num >= 8){
          this.$message({
            type: "error",
            message: "根据中国足协提供的培训指导手册排版限制，执教经历、运动经历、其他相关经历一共最多可写8条"
          });
          return;
        }
        this.resumeDataForm.resumeDataOther.push({
          content:'',
          type:'other',
        })
      },
      delOther(idx){
        if (this.resumeDataForm.resumeDataOther.length === 1) return;
        this.resumeDataForm.resumeDataOther.splice(idx, 1);
      },
      imgError() {
        this.$set(this.userInfo, "profile_picture", this.userImg);
      },
      checkForm() {
        this.$refs["resumeDataForm"].validate((valid) => {
          if (valid) {
            this.makeSureSubmit();
          } else {
            this.$message({
              type: "error",
              message: "请完善所有带*号的必填项"
            });
            console.error('error submit!!');
            return false;
          }
        });
      },
      makeSureSubmit() {
        this.submitTips = true;
      },
      hideSubmitTips(bool, flag) {
        if (flag) {
          this.submitForm();
        }
        this.submitTips = bool;
      },
      
      submitForm() {
        // 拼接成一个数组
        let resumeData = this.resumeDataForm.resumeDataCoach.concat(this.resumeDataForm.resumeDataPlay).concat(this.resumeDataForm.resumeDataOther);
        const form = {
          teacher_resume_list: JSON.stringify(resumeData)
        };
        console.log(form)
        teacherResumeSave(form).then(({data}) => {
          // console.log(data);
          if (Number(data.status) === 0) {
            this.$message.success("信息保存成功");
            // 路由跳转
            this.goBack();
          }else{
            this.$message.error(data.msg);
          }
        })
        .catch((err) => {
          console.error(err);
        });
      },
      makeSureBack() {
        this.backTips = true;
      },
      hideBackTips(bool, flag) {
        if (flag) {
          this.goBack();
        }
        this.backTips = bool;
      },
      downResume(){
        getTeacherResumeDown().then(({ data }) => {
          if (data.status === correctStatus) {
            downfile(data.result.file_url);
          } else {
            this.$message.error(`下载失败, ${data.msg}`);
          }
        });
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/mixin';

  .stuDetailNav, .stuDetailMain {
    flex: 1 1 auto;
    height: 100%;
  }

  .stuDetailNav {
    display: flex;
    align-items: center;
    font-size: $font_size_big;
    justify-content:space-between
    .downResume{
      margin-right:30px;
      cursor:pointer;
      background-color:$color_suc
      padding: 5px 10px;
    }
  }

  .stuDetailMain {
    width: 100%;
    height:560px
    background-color: $block_bg_color_base;
    .scrollArea {
      width: 100%;
      height: 100%;
      padding: 30px 0 25px 30px;
      .contentWrap {
        padding: 0 30px 0 0;
        .content {
          .itemWrap {
            margin: 0 0 30px 0;
            .titleWrap {
              margin: 0 0 19px 0;
              display: flex;
              justify-content: space-between;
              font-size: 20px;
              user-select: none;
              .title {
                display: flex;
                align-items: flex-end;
                .logo {
                  margin: 0 10px 0 0;
                }
                p {
                  line-height: 20px;
                  span {
                    margin: 0 0 0 10px;
                    font-size: $font_size_medium;
                  }
                }
              }
              .moreBtn {
                cursor: pointer;
              }
            }
            .stuInfo {
              display: flex;
              font-size: $font_size_big;
              border: 1px solid $color_white;
              .left {
                width: 77%;
                .tr {
                  height: 60px;
                  display: flex;
                  border-bottom: 1px solid $color_white;
                  .info_left{
                    width: 50%;
                    border-right: 1px solid #fff;
                  }
                  .td {
                    padding: 2px 0 2px 20px;
                    display: flex;
                    align-items: center;
                  }
                  /*.td:first-child {
                    width: 65%;
                    padding: 0 0 0 20px;
                  }
                  .td:last-child {
                    width: 35%;
                  }*/
                }
                .tr:last-child {
                  border-bottom: none;
                }
                .level{
                  display: grid;
                  min-height: 60px;
                  height: auto;
                  align-items:center
                }
              }
              .right {
                width: 23%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center
                border-left: 1px solid $color_white;
                img {
                  width: 105px;
                  height: 130px;
                  /*border-radius: 50%;*/
                }
                .name {
                  // word-break break-word
                  word-break break-all
                  text-align center
                  word-wrap break-word
                  width 100%
                  margin-top 5px
                }
              }
            }
            .vita-form-fieldset {
              margin: 20px 0;
              padding: 10px 10px 0;
              border: 1px solid $color_white;
              .vita-edu-row {
                margin: 0 0 10px 0;
                padding: 10px 0 0;
                border: 1px solid $color_white;
              }
              .exp-opt {
                justify-content: space-between;
                display: flex;
              }
            }
          }
          .itemWrap:last-child{
            margin:0;
          }
        }
      }
    }
    .btns {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      /*background-color: $color_err;*/
    }
  }

.red-text
  color $color_both_err
.link-doc
  cursor pointer
  user-select none
  &.suc
    color $color_suc
</style>
<style lang="stylus">
  .stuDetailMain {
    .vita-form-fieldset {
      .el-form-item__label{
        color white
      }
    }
  }
</style>
